import { useContext } from "react";

import {
  ChangelogOpenContext,
  type ChangelogOpenContextValue,
} from "../contexts/ChangelogOpen";

const useChangelogOpenContext = () => {
  const changelogOpenContext = useContext<
    ChangelogOpenContextValue | undefined
  >(ChangelogOpenContext);

  if (!changelogOpenContext) {
    return {
      isOpen: false,
      setIsOpen() {
        console.error("No ChangelogOpenContextProvider found");
      },
    };
  }

  return changelogOpenContext;
};

export default useChangelogOpenContext;
